import { Project } from "../../api/models/project";
import { Property } from "../../api/models/property";
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from "../utils";

const ACTION_REQUEST_COMPARE_INITIATE = "_COMPARE/REQUEST_INITIATE";
const ACTION_REQUEST_COMPARE_COMPLETE = "_COMPARE/REQUEST_COMPLETE";
const ACTION_LOADED_PROJECT_COMPARE = "_COMPARE/PROJECT/LOADED";
const ACTION_LOADED_PROPERTY_COMPARE = "_COMPARE/PROPERTY/LOADED";
const ACTION_ERROR_COMPARE = "_COMPARE/ERROR";

// const ACTION_REQUEST_COMPARE_SET_PROJECT = "_COMPARE/SET_PROJECT";
// const ACTION_REQUEST_COMPARE_SET_PROPERTY = "_COMPARE/SET_PROPERTY";

export interface ICompareState {
  projects: Project[];
  property: Property[];
  loaded?: boolean;
  loading?: boolean;
  error?: string;
}

const initialState: ICompareState = {
  projects: [],
  property: [],
  loaded: false,
  loading: false,
};
// {
//   projects: [
//     {
//       _id: "65d8e8c311b27a48c1b85a9e",
//       projectID: "6963",
//       projectName: "IndiQube - Royal Arcade",
//       projectBuilderName: "Innovent Spaces Pvt. Ltd. (IndiQube)",
//       propertyTypeKey: "business_center_co_working_space",
//       projectAddress1:
//         "Royal Arcade, 80 Feet Road, KHB Colony, Koramangala Industrial Layout, Koramangala, Bengaluru, Karnataka 560034",
//       projectAddress2: "",
//       projectCurrentStatus: "Operational",
//       checkRental: "0",
//       projectTypeID: "16",
//       totalBuiltupArea: "~20,000",
//       propertyUnitSqftRange: "30 - 142",
//       projectDescription: "IndiQube - Royal Arcade",
//       propertyUnitBedRooms: "",
//       propertyUnitPriceRange: "",
//       propertyUnitPriceRangeMap: "0",
//       projectKey: "OCL29F3",
//       propertyPurpose: "Rent",
//       cityID: "5",
//       city: {
//         cityID: "5",
//         cityKeyID: "bangalore",
//         cityName: "Bangalore",
//         stateID: 2,
//         countryID: 99,
//         countryName: "India",
//         stateName: "Karnataka",
//         stateUrlKey: "karnataka",
//         citybgImage: "",
//         citylogoImage: "",
//         cityLat: 12.9279232,
//         cityLng: 77.6271078,
//         isDefault: "Yes",
//         cityImageName: "",
//         _id: "64e915ae39e40e122a25dacf",
//         createdAt: "2023-08-25T20:57:18.729Z",
//         updatedAt: "2023-08-25T20:57:18.729Z",
//         __v: 0,
//       },
//       cityLocationID: "7",
//       cityLocation: {
//         cityId: "64e915ae39e40e122a25dacf",
//         cityLocID: 7,
//         cityID: 5,
//         cityLocUrlKey: "koramangala",
//         cityLocLat: 12.9279232,
//         cityLocLng: 77.6271078,
//         cityLocStatus: "Active",
//         googleLocName: "Koramangala",
//         cityLocPoint: 3.8,
//         cityLocDetailsID: 13,
//         languageID: 1,
//         cityLocName: "Koramangala",
//         cityLocTips: "Koramangala",
//         cityDetailsID: 11,
//         cityName: "Bangalore",
//         province: "",
//         cityDescription: "",
//         location: {
//           type: "Point",
//           coordinates: [77.6271078, 12.9279232],
//         },
//         _id: "64e915e839e40e122a25dd4e",
//         createdAt: "2023-08-25T20:58:16.765Z",
//         updatedAt: "2024-02-23T17:31:13.362Z",
//         __v: 0,
//       },
//       cityLocName: "Koramangala",
//       propertyUpdateDate: "2024-02-22 15:11:25",
//       projectAddedDate: "2024-02-22 15:03:49",
//       projectAddedAt: "2024-02-22T09:33:49.000Z",
//       possessionDate: "",
//       projectPossessionDate: "",
//       projectUserCompanyName: "",
//       projectUserCompanyLogo: "",
//       projectCoverImage:
//         "https://cf-cdn.cityinfoservices.com/public/uploads/project/images/large/6756665d7153474e4cIndiQube - Royal Arcade.jpg",
//       propertySqrFeet: "",
//       userTypeID: "4",
//       userID: "1",
//       type: "Co-working Space",
//       numberOfSeats: "73",
//       publicDisplay: "Yes",
//       currencyID_6: "0",
//       propertyPrices: {
//         "6": 0,
//       },
//       pricesPerSqfts: {
//         "6": 0,
//       },
//       pricePerSqft: "",
//       rawPricePerSqft: "0",
//       rentUnitCount: 5,
//       sellUnitCount: 0,
//       link: "indiqube-royal-arcade-koramangala-bangalore/ocl29f3/pjd",
//       uniqueArray: [],
//       propertyUnitIDs: "18528,18529,18530,18531,18532",
//       amenities: [
//         {
//           attrOptionID: 25,
//           attrOptName: "24x7 Security",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_25_.png",
//         },
//         {
//           attrOptionID: 26,
//           attrOptName: "BMS",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_26_.png",
//         },
//         {
//           attrOptionID: 27,
//           attrOptName: "CCTV",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_27_.png",
//         },
//         {
//           attrOptionID: 29,
//           attrOptName: "Lift",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_29_.png",
//         },
//         {
//           attrOptionID: 71,
//           attrOptName: "Boom Barriers",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_71_.png",
//         },
//         {
//           attrOptionID: 73,
//           attrOptName: "Power Backup",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_73_.png",
//         },
//         {
//           attrOptionID: 74,
//           attrOptName: "Fire Fighting Equipment’s",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_74_.png",
//         },
//         {
//           attrOptionID: 197,
//           attrOptName: "Visitors Parking",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_197_.png",
//         },
//       ],
//       unitDetails: [
//         {
//           propertyId: "65d8e59d047a25dd4228904e",
//           unitID: "77898",
//           floorID: "6820",
//           floorDetailID: "83307",
//           unitName: "Office 1",
//           unitArea: "73",
//           propertyID: "18528",
//           unitStatus: "Active",
//           floorName: 0,
//           propertyName: "IndiQube - Royal Arcade - Ground Floor",
//           // floorId: "65098ada54ab3f34efbd8bee",
//           // _id: "65d8e8c311b27a48c1b85aa1",
//           // createdAt: "2024-02-23T18:49:39.679Z",
//           // updatedAt: "2024-02-23T18:49:39.679Z",
//         },
//         {
//           propertyId: "65d8e59d047a25dd42289046",
//           unitID: '77899',
//           floorID: '6820',
//           floorDetailID: '83307',
//           unitName: "Office 2",
//           unitArea: '130',
//           propertyID: '18529',
//           unitStatus: "Active",
//           floorName: 0,
//           propertyName: "IndiQube - Royal Arcade - First Floor",
//           // floorId: "65098ada54ab3f34efbd8bee",
//           // _id: "65d8e8c311b27a48c1b85aa2",
//           // createdAt: "2024-02-23T18:49:39.679Z",
//           // updatedAt: "2024-02-23T18:49:39.679Z",
//         },
//         {
//           propertyId: "65d8e59d047a25dd4228903e",
//           unitID: '77900',
//           floorID: '6820',
//           floorDetailID: '83307',
//           unitName: "Office 3",
//           unitArea: '130',
//           propertyID: '18530',
//           unitStatus: "Active",
//           floorName: 0,
//           propertyName: "IndiQube - Royal Arcade - Second Floor",
//           // floorId: "65098ada54ab3f34efbd8bee",
//           // _id: "65d8e8c311b27a48c1b85aa3",
//           // createdAt: "2024-02-23T18:49:39.679Z",
//           // updatedAt: "2024-02-23T18:49:39.679Z",
//         },
//         {
//           propertyId: "65d8e59d047a25dd42289036",
//           unitID: '77901',
//           floorID: '6820',
//           floorDetailID: '83307',
//           unitName: "Office 4",
//           unitArea: '142',
//           propertyID: '18531',
//           unitStatus: "Active",
//           floorName: 0,
//           propertyName: "IndiQube - Royal Arcade - Third Floor",
//           // floorId: "65098ada54ab3f34efbd8bee",
//           // _id: "65d8e8c311b27a48c1b85aa4",
//           // createdAt: "2024-02-23T18:49:39.679Z",
//           // updatedAt: "2024-02-23T18:49:39.679Z",
//         },
//         {
//           propertyId: "65d8e59d047a25dd4228902e",
//           unitID: '77902',
//           floorID: '6820',
//           floorDetailID: '83307',
//           unitName: "Office 5",
//           unitArea: '142',
//           propertyID: '18532',
//           unitStatus: "Active",
//           floorName: 0,
//           propertyName: "IndiQube - Royal Arcade - Fourth Floor",
//           // floorId: "65098ada54ab3f34efbd8bee",
//           // _id: "65d8e8c311b27a48c1b85aa5",
//           // createdAt: "2024-02-23T18:49:39.679Z",
//           // updatedAt: "2024-02-23T18:49:39.679Z",
//         },
//       ],
//       attributes: [
//         {
//           attrGroupName: "FEATURES",
//           attrID: 127,
//           attrKey: "type",
//           attrName: "Type",
//           attrOptionValue: "Co-working Space",
//         },
//         {
//           attrGroupName: "FEATURES",
//           attrID: 116,
//           attrKey: "total-seats",
//           attrName: "Total Seats",
//           attrOptionValue: 617,
//         },
//         {
//           attrGroupName: "FEATURES",
//           attrID: 119,
//           attrKey: "parking-facility",
//           attrName: "Parking Facility",
//           attrOptionValue: "Paid Parking",
//         },
//       ],
//       resImages: [
//         {
//           projectImageName: "2774765d7150edff251.jpg",
//           projectImageID: 17298,
//           projectID: 6963,
//           projectImageTitle: "",
//           projectImageAltTag: "",
//           imageCatID: 2,
//         },
//         {
//           projectImageName: "3680365d715129ca942.jpg",
//           projectImageID: 17299,
//           projectID: 6963,
//           projectImageTitle: "",
//           projectImageAltTag: "",
//           imageCatID: 2,
//         },
//         {
//           projectImageName: "5509565d715171a5c43.jpg",
//           projectImageID: 17300,
//           projectID: 6963,
//           projectImageTitle: "",
//           projectImageAltTag: "",
//           imageCatID: 2,
//         },
//         {
//           projectImageName: "2458965d7151eca8f84.jpg",
//           projectImageID: 17301,
//           projectID: 6963,
//           projectImageTitle: "",
//           projectImageAltTag: "",
//           imageCatID: 2,
//         },
//         {
//           projectImageName: "7730465d7152281aa05.jpg",
//           projectImageID: 17302,
//           projectID: 6963,
//           projectImageTitle: "",
//           projectImageAltTag: "",
//           imageCatID: 2,
//         },
//         {
//           projectImageName: "355965d715270e9326.jpg",
//           projectImageID: 17303,
//           projectID: 6963,
//           projectImageTitle: "",
//           projectImageAltTag: "",
//           imageCatID: 2,
//         },
//         {
//           projectImageName: "2639365d7152b89c767.jpg",
//           projectImageID: 17304,
//           projectID: 6963,
//           projectImageTitle: "",
//           projectImageAltTag: "",
//           imageCatID: 2,
//         },
//         {
//           projectImageName: "855765d7152f950208.jpg",
//           projectImageID: 17305,
//           projectID: 6963,
//           projectImageTitle: "",
//           projectImageAltTag: "",
//           imageCatID: 2,
//         },
//         {
//           projectImageName: "6756665d7153474e4cIndiQube - Royal Arcade.jpg",
//           projectImageID: 17306,
//           projectID: 6963,
//           projectImageTitle: "",
//           projectImageAltTag: "",
//           imageCatID: 2,
//         },
//       ],
//       totalBuiltUpAreaSqFt: 20000,
//       rawTotalBuiltUpAreaSqFt: "~20,000",
//       noOfFloors: "Basement + Ground + 4 Floors",
//       perFloorAreaSqFt: "~4,000",
//       occupancyCertificate: "Available",
//       fireNoc: "Available",
//       projectTypeName: "Business Center & Co-working Space",
//       countryName: "India",
//       stateName: "Karnataka",
//       zipCode: "560034",
//       projectLatitude: '12.935271',
//       projectLongitude: '77.614785',
//       projectOffer: "IndiQube - Royal Arcade",
//       projectStatus: "Active",
//       projectMaxPrice: "",
//       projectBannerImage:
//         "https://cf-cdn.cityinfoservices.com/public/uploads/projectBanner/large/IndiQube - Royal Arcade__1889329999.jpg",
//       projectMinPrice: "",
//       imagePath:
//         "https://cf-cdn.cityinfoservices.com//public/uploads/project/images/",
//       document: [],
//       secondaryLocality: [],
//       projImageCat: [
//         {
//           imageCatID: 2,
//           imageCatName: "Gallery",
//           imageCatKey: "gallery",
//           imgCount: 9,
//         },
//       ],
//       cityZone: {
//         cityId: "64e915ae39e40e122a25dacf",
//         cityZoneID: 7,
//         cityID: 5,
//         cityZoneName: "Secondary Business District (SBD)",
//         cityZoneStatus: "Active",
//         cityName: "Bangalore",
//         _id: "64e915bf39e40e122a25db1b",
//         createdAt: "2023-08-25T20:57:35.836Z",
//         updatedAt: "2023-08-25T20:57:35.836Z",
//         __v: 0,
//       },
//       tenantDetails: [
//         {
//           floorNum: 0,
//           totalFloorArea: 10000,
//           _id: "65d8e8c311b27a48c1b85aa7",
//           unitDetails: [],
//         },
//       ],
//       projectFeatured: "OFF",
//       propertyPurposes: ["Rent"],
//       propertyTypeKeys: ["business-center-co-working-space"],
//       interiorTypes: ["Warm Shell"],
//       propertyDetails: [
//         {
//           // propertyID: '18528',
//           propertyBuiltUpArea: 5840,
//           numberofSeats: 73,
//           // propertyTypeKey: "business-center-co-working-space",
//           // propertyPurpose: "Rent",
//           propertyPrice: 0,
//           // furnishingStatus: "Warm Shell",
//           pricePerSqft: 0,
//         },
//         {
//           // propertyID: 18529,
//           propertyBuiltUpArea: 10400,
//           numberofSeats: 130,
//           // propertyTypeKey: "business-center-co-working-space",
//           // propertyPurpose: "Rent",
//           propertyPrice: 0,
//           // furnishingStatus: "Warm Shell",
//           pricePerSqft: 0,
//         },
//         {
//           // propertyID: 18530,
//           propertyBuiltUpArea: 2400,
//           numberofSeats: 30,
//           // propertyTypeKey: "business-center-co-working-space",
//           // propertyPurpose: "Rent",
//           propertyPrice: 0,
//           // furnishingStatus: "Warm Shell",
//           pricePerSqft: 0,
//         },
//         {
//           // propertyID: 18531,
//           propertyBuiltUpArea: 11360,
//           numberofSeats: 142,
//           // propertyTypeKey: "business-center-co-working-space",
//           // propertyPurpose: "Rent",
//           propertyPrice: 0,
//           // furnishingStatus: "Warm Shell",
//           pricePerSqft: 0,
//         },
//         {
//           // propertyID: 18532,
//           propertyBuiltUpArea: 11360,
//           numberofSeats: 142,
//           // propertyTypeKey: "business-center-co-working-space",
//           // propertyPurpose: "Rent",
//           propertyPrice: 0,
//           // furnishingStatus: "Warm Shell",
//           pricePerSqft: 0,
//         },
//       ],
//       allPropertyAttributes: [],
//       __v: 0,
//       // createdAt: "2024-02-23T18:49:39.679Z",
//       // updatedAt: "2024-02-23T18:49:39.679Z",
//       properties: [],
//     },
//     {
//       _id: "65d8e824047a25dd422a369a",
//       projectID: '6966',
//       projectName: "Urban Vault - HSR 1165",
//       projectBuilderName: "Urban Vault Companies Pvt. Ltd.",
//       propertyTypeKey: "business_center_co_working_space",
//       projectAddress1:
//         "24th Main Road, Garden Layout, Sector 2, HSR Layout, Bengaluru, Karnataka 560102",
//       projectAddress2: "",
//       projectCurrentStatus: "Operational",
//       checkRental: "1",
//       projectTypeID: '16',
//       totalBuiltupArea: "~32,000",
//       propertyUnitSqftRange: "315",
//       projectDescription: "Urban Vault - HSR 1165",
//       propertyUnitBedRooms: "",
//       propertyUnitPriceRange: "6499 ",
//       propertyUnitPriceRangeMap: "0",
//       projectKey: "CZDUGM2",
//       propertyPurpose: "Rent",
//       cityID: '5',
//       city: {
//         cityID: 5,
//         cityKeyID: "bangalore",
//         cityName: "Bangalore",
//         stateID: 2,
//         countryID: 99,
//         countryName: "India",
//         stateName: "Karnataka",
//         stateUrlKey: "karnataka",
//         citybgImage: "",
//         citylogoImage: "",
//         cityLat: 12.9279232,
//         cityLng: 77.6271078,
//         isDefault: "Yes",
//         cityImageName: "",
//         _id: "64e915ae39e40e122a25dacf",
//         createdAt: "2024-06-05T09:58:59.996Z",
//         updatedAt: "2024-06-05T09:58:59.996Z",
//         __v: 0,
//       },
//       cityLocationID: '243',
//       cityLocation: {
//         cityId: "64e915ae39e40e122a25dacf",
//         cityLocID: 243,
//         cityID: 5,
//         cityLocUrlKey: "hsr-layout",
//         cityLocLat: 12.9131707,
//         cityLocLng: 77.6259774,
//         cityLocStatus: "Active",
//         googleLocName: "HSR Layout",
//         cityLocPoint: 3.7,
//         cityLocDetailsID: 487,
//         languageID: 1,
//         cityLocName: "HSR Layout",
//         cityLocTips: "HSR Layout",
//         cityDetailsID: 11,
//         cityName: "Bangalore",
//         province: "",
//         cityDescription: "",
//         location: {
//           type: "Point",
//           coordinates: [77.6259774, 12.9131707],
//         },
//         _id: "64e915e839e40e122a25dcb9",
//         createdAt: "2024-06-05T09:58:59.996Z",
//         updatedAt: "2024-06-05T09:58:59.996Z",
//         __v: 0,
//       },
//       cityLocName: "HSR Layout",
//       propertyUpdateDate: "2024-05-09 14:35:27",
//       projectAddedDate: "2024-02-23 11:11:23",
//       // projectAddedAt: "2024-02-23T05:41:23.000Z",
//       possessionDate: "",
//       projectPossessionDate: "",
//       projectUserCompanyName: "",
//       projectUserCompanyLogo: "",
//       projectCoverImage:
//         "https://cf-cdn.cityinfoservices.com/public/uploads/project/images/large/2327465d8300cb503dUrban Vault - HSR 1165.jpg",
//       propertySqrFeet: "",
//       userTypeID: '4',
//       userID: '1',
//       type: "Co-working Space",
//       numberOfSeats: '315',
//       publicDisplay: "Yes",
//       currencyID_6: '2047185',
//       propertyPrices: {
//         "6": '2047185',
//       },
//       pricesPerSqfts: {
//         "6": 81.2375,
//       },
//       pricePerSqft: '81.2375',
//       // rawPricePerSqft: "81.2375",
//       rentUnitCount: 1,
//       sellUnitCount: 0,
//       link: "urban-vault-hsr-1165-hsr-layout-bangalore/czdugm2/pjd",
//       uniqueArray: [],
//       propertyUnitIDs: "18536",
//       amenities: [
//         {
//           attrOptionID: 25,
//           attrOptName: "24x7 Security",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_25_.png",
//         },
//         {
//           attrOptionID: 27,
//           attrOptName: "CCTV",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_27_.png",
//         },
//         {
//           attrOptionID: 29,
//           attrOptName: "Lift",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_29_.png",
//         },
//         {
//           attrOptionID: 72,
//           attrOptName: "Power",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_72_.png",
//         },
//         {
//           attrOptionID: 73,
//           attrOptName: "Power Backup",
//           attrOptionImage:
//             "https://cf-cdn.cityinfoservices.com/public/uploads/attributes/amenities-project_5_opt_73_.png",
//         },
//       ],
//       unitDetails: [
//         {
//           propertyId: "65d8e59d047a25dd42289018",
//           unitID: '77923',
//           floorID: '6823',
//           floorDetailID: '83315',
//           unitName: "Office 1",
//           unitArea: '315',
//           propertyID: '18536',
//           unitStatus: "Active",
//           floorName: 0,
//           propertyName: "Urban Vault - HSR 1165 - Upper Floors",
//           // floorId: "65098ada54ab3f34efbd8bee",
//           // _id: "666036e4cb8af5c5cb2df31a",
//           // createdAt: "2024-06-05T09:58:59.996Z",
//           // updatedAt: "2024-06-05T09:58:59.996Z",
//         },
//       ],
//       attributes: [
//         {
//           attrGroupName: "FEATURES",
//           attrID: 127,
//           attrKey: "type",
//           attrName: "Type",
//           attrOptionValue: "Co-working Space",
//         },
//         {
//           attrGroupName: "FEATURES",
//           attrID: 116,
//           attrKey: "total-seats",
//           attrName: "Total Seats",
//           attrOptionValue: 315,
//         },
//       ],
//       resImages: [
//         {
//           projectImageName: "2327465d8300cb503dUrban Vault - HSR 1165.jpg",
//           projectImageID: 17310,
//           projectID: 6966,
//           projectImageTitle: "",
//           projectImageAltTag: "",
//           imageCatID: 2,
//         },
//       ],
//       totalBuiltUpAreaSqFt: 32000,
//       // rawTotalBuiltUpAreaSqFt: "~32,000",
//       // noOfFloors: "Basement + Ground + 7 Floors",
//       // perFloorAreaSqFt: "~4,000",
//       projectTypeName: "Business Center & Co-working Space",
//       countryName: "India",
//       stateName: "Karnataka",
//       zipCode: "560102",
//       projectLatitude: '12.905083',
//       projectLongitude: '77.649168',
//       // projectOffer: "Urban Vault - HSR 1165",
//       // projectStatus: "Active",
//       // projectMaxPrice: "",
//       projectBannerImage:
//         "https://cf-cdn.cityinfoservices.com/public/uploads/projectBanner/large/Urban Vault - HSR 1165__897644796.jpg",
//       // projectMinPrice: "",
//       imagePath:
//         "https://cf-cdn.cityinfoservices.com//public/uploads/project/images/",
//       // document: [],
//       // secondaryLocality: [],
//       // projImageCat: [
//       //   {
//       //     imageCatID: 2,
//       //     imageCatName: "Gallery",
//       //     imageCatKey: "gallery",
//       //     imgCount: 1,
//       //   },
//       // ],
//       // cityZone: {
//       //   cityId: "64e915ae39e40e122a25dacf",
//       //   cityZoneID: 12,
//       //   cityID: 5,
//       //   cityZoneName: "HSR Layout",
//       //   cityZoneStatus: "Active",
//       //   cityName: "Bangalore",
//       //   cityLocations: [
//       //     {
//       //       cityName: "Bangalore",
//       //       cityLocName: "HSR Layout",
//       //       _id: "64e915e839e40e122a25dcb9",
//       //     },
//       //   ],
//       //   _id: "64e915bf39e40e122a25db15",
//       //   createdAt: "2024-06-05T09:58:59.996Z",
//       //   updatedAt: "2024-06-05T09:58:59.996Z",
//       //   __v: 0,
//       // },
//       tenantDetails: [
//         {
//           floorNum: 0,
//           totalFloorArea: 10000,
//           unitDetails: [
//             {
//               unitName: "Office 1",
//               unitArea: 315,
//               propertyID: 18536,
//               tenantsName: "",
//               tenantsUrlKey: "",
//               currentStatus: "Available",
//               propertyTypeName: "Business Center &amp; Co-working Space",
//               propertySqrFeet: "25200Sq.Ft",
//               floorOffered: "Upper Floors",
//               propertyCurrentStatus: "Ready to move",
//               interior: "Warm Shell",
//               interiorTypes: [],
//               link:
//                 "urban-vault-hsr-1165-for-rent-in-hsr-layout-bangalore/i46rjz8/prd",
//               fullLink:
//                 "https://properties.cityinfoservices.com//urban-vault-hsr-1165-for-rent-in-hsr-layout-bangalore/i46rjz8/prd",
//               tenantStartDate: "",
//               tenantEndDate: "",
//               tenantID: 0,
//               _id: "666036e4cb8af5c5cb2df319",
//             },
//           ],
//           _id: "666036e4cb8af5c5cb2df318",
//         },
//       ],
//       // projectFeatured: "OFF",
//       // propertyPurposes: ["Rent"],
//       // propertyTypeKeys: ["business-center-co-working-space"],
//       // interiorTypes: ["Warm Shell"],
//       propertyDetails: [
//         {
//           // propertyID: '18536',
//           propertyBuiltUpArea: 25200,
//           numberofSeats: 315,
//           // propertyTypeKey: "business-center-co-working-space",
//           // propertyPurpose: "Rent",
//           propertyPrice: 2047185,
//           // furnishingStatus: "Warm Shell",
//           pricePerSqft: 81,
//         },
//       ],
//       // allPropertyAttributes: [],
//       // __v: 0,
//       // createdAt: "2024-02-23T18:47:00.774Z",
//       // updatedAt: "2024-06-05T09:58:59.996Z",
//       // fireNoc: "Available",
//       grade: "A",
//       // occupancyCertificate: "Available",
//       projectFloorImage:
//         "https://cf-cdn.cityinfoservices.com/public/uploads/project/floorImages/BNB Prime__449731497.jpg",
//       totalSeats: 315,
//       // rentUnitSeatCount: '315',
//       // sellUnitSeatCount: "",
//       properties: [],
//     },
//   ],
//   property: [],
//   loaded: true,
//   loading: false,
// };

type RequestCompareInitiateActionType = IAction<
  typeof ACTION_REQUEST_COMPARE_INITIATE
>;
type RequestCompareCompleteActionType = IAction<
  typeof ACTION_REQUEST_COMPARE_COMPLETE
>;

type CompareProjectLoadedActionType = IActionWithPayload<
  typeof ACTION_LOADED_PROJECT_COMPARE,
  Project[]
>;
type ComparePropertyLoadedActionType = IActionWithPayload<
  typeof ACTION_LOADED_PROPERTY_COMPARE,
  Property[]
>;

type CompareErrorActionType = IActionWithPayload<
  typeof ACTION_ERROR_COMPARE,
  string
>;

type Actions =
  | RequestCompareInitiateActionType
  | RequestCompareCompleteActionType
  | CompareProjectLoadedActionType
  | ComparePropertyLoadedActionType
  | CompareErrorActionType;

export const requestCompareInitiateAction = (): RequestCompareInitiateActionType => {
  return createAction(ACTION_REQUEST_COMPARE_INITIATE);
};
export const requestCompareCompleteAction = (): RequestCompareCompleteActionType => {
  return createAction(ACTION_REQUEST_COMPARE_COMPLETE);
};

export const compareProjectLoadedAction = (
  data: Project[]
): CompareProjectLoadedActionType => {
  return createActionWithPayload(ACTION_LOADED_PROJECT_COMPARE, data);
};
export const comparePropertyLoadedAction = (
  data: Property[]
): ComparePropertyLoadedActionType => {
  return createActionWithPayload(ACTION_LOADED_PROPERTY_COMPARE, data);
};

export const compareErrorAction = (error: string): CompareErrorActionType => {
  return createActionWithPayload(ACTION_ERROR_COMPARE, error);
};

// reducer
export const compareReducer = (
  state: ICompareState = initialState,
  action: Actions
): ICompareState => {
  switch (action.type) {
    case ACTION_REQUEST_COMPARE_INITIATE:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case ACTION_REQUEST_COMPARE_COMPLETE:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case ACTION_LOADED_PROJECT_COMPARE: {
      // console.log("ACTION_LOADED_PROJECT_COMPARE", action.payload);
      return {
        ...state,
        loaded: true,
        loading: false,
        projects: action.payload,
      };
    }
    case ACTION_LOADED_PROPERTY_COMPARE: {
      // console.log("ACTION_LOADED_PROJECT_COMPARE", state);
      return {
        ...state,
        loaded: true,
        loading: false,
        property: action.payload,
      };
    }
    case ACTION_ERROR_COMPARE:
      return {
        ...state,
        loaded: true,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
